module.exports = __webpack_public_path__ + "resources/img/img_magic_line_m_en.0d3f64a08e09e3ab632cf24648052fe3.png";